import type { ConsoleProfile } from "@/components/ApiTestConsole";

const newAPIChannel = JSON.stringify({
  mode: "single",
  channel: { name: "supplier-openai", type: 1, key: "REPLACE_WITH_UPSTREAM_KEY", models: "gpt-4o-mini", group: "default", status: 1, tag: "wc-123", priority: 6 },
}, null, 2);

// newapi-seller:new-api 闭源魔改 fork 的卖家控制台(role=5)。协议差异与
// admin 有三处硬区别,都被后端 profile 强制:
//   1. 创建仍是 {mode,channel} 包裹,但**不带 tag / priority**(fork 无此字段);
//   2. 更新必须是**扁平** {id,...},带 channel 包裹会 200 成功但什么都不改;
//   3. 更新体带 priority/weight 会整条 403(路由策略字段未授权编辑)。
// 路径前缀默认 seller,同质站点(zzz/supplier)由 profileForSite 按站点的
// 业务模块路径动态重写,不需要在这里再维护一份 profile。
const newAPISellerChannel = JSON.stringify({
  mode: "single",
  channel: { name: "supplier-openai", type: 1, key: "REPLACE_WITH_UPSTREAM_KEY", models: "gpt-4o-mini", group: "default", status: 1 },
}, null, 2);

const sub2APIChannel = JSON.stringify({
  name: "supplier-openai", type: "openai", key: "REPLACE_WITH_UPSTREAM_KEY", base_url: "", models: "gpt-4o-mini", group: "default",
}, null, 2);

export const RELAY_PROFILES: Record<string, ConsoleProfile> = {
  newapi: {
    label: "newapi · 中转站 Open API",
    baseUrl: "",
    endpoints: [
      { idx: 0, m: "GET", path: "/api/status", hasBody: false, hasQuery: false, note: "站点状态与版本" },
      { idx: 1, m: "GET", path: "/api/channel/", hasBody: false, hasQuery: true, note: "渠道列表" },
      { idx: 2, m: "GET", path: "/api/channel/{id}", hasBody: false, hasQuery: false, note: "渠道详情" },
      { idx: 3, m: "POST", path: "/api/channel/", hasBody: true, hasQuery: false, note: "创建渠道", mutating: true },
      { idx: 4, m: "PUT", path: "/api/channel/", hasBody: true, hasQuery: false, note: "更新渠道，body 顶层需带 id", mutating: true },
      { idx: 5, m: "POST", path: "/api/channel/{id}/status", hasBody: true, hasQuery: false, note: "启用或禁用渠道", mutating: true },
      { idx: 6, m: "DELETE", path: "/api/channel/{id}", hasBody: false, hasQuery: false, note: "删除渠道", mutating: true },
    ],
    defaultBodies: { "/api/channel/": newAPIChannel, "/api/channel/{id}/status": JSON.stringify({ status: 2 }, null, 2) },
    defaultQueries: { "/api/channel/": JSON.stringify({ p: "1", page_size: "20", tag_mode: "true", tag: "", status: "", type: "" }, null, 2) },
  },
  "newapi-seller": {
    label: "newapi-seller · 卖家控制台",
    baseUrl: "",
    endpoints: [
      { idx: 0, m: "GET", path: "/api/status", hasBody: false, hasQuery: false, note: "站点状态与版本" },
      { idx: 1, m: "GET", path: "/api/seller/channel/", hasBody: false, hasQuery: true, note: "渠道列表（分页 p / keyword / id_sort）" },
      { idx: 2, m: "GET", path: "/api/seller/channel/{id}", hasBody: false, hasQuery: false, note: "渠道详情（先替换路径里的 {id}）" },
      { idx: 3, m: "POST", path: "/api/seller/channel/", hasBody: true, hasQuery: false, note: "创建渠道（包裹 body；不带 tag/priority；不返回 id）", mutating: true },
      { idx: 4, m: "PUT", path: "/api/seller/channel/", hasBody: true, hasQuery: false, note: "更新渠道（扁平 body · 顶层 id · 禁止 priority/weight）", mutating: true },
      { idx: 5, m: "POST", path: "/api/seller/channel/{id}/status", hasBody: true, hasQuery: false, note: "启用或禁用（真实写操作）", mutating: true },
      { idx: 6, m: "DELETE", path: "/api/seller/channel/{id}", hasBody: false, hasQuery: false, note: "删除渠道（真实删操作）", mutating: true },
    ],
    defaultBodies: {
      "/api/seller/channel/": newAPISellerChannel,
      "/api/seller/channel/{id}/status": JSON.stringify({ status: 2 }, null, 2),
    },
    defaultQueries: {
      "/api/seller/channel/": JSON.stringify({ p: "1", page_size: "20", keyword: "", id_sort: "true", type: "" }, null, 2),
    },
  },
  sub2api: {
    label: "sub2api · 中转站 Admin API",
    baseUrl: "",
    endpoints: [
      { idx: 0, m: "GET", path: "/api/v1/admin/channels", hasBody: false, hasQuery: true, note: "渠道列表" },
      { idx: 1, m: "GET", path: "/api/v1/admin/channels/{id}", hasBody: false, hasQuery: false, note: "渠道详情" },
      { idx: 2, m: "POST", path: "/api/v1/admin/channels", hasBody: true, hasQuery: false, note: "创建渠道", mutating: true },
      { idx: 3, m: "PUT", path: "/api/v1/admin/channels/{id}", hasBody: true, hasQuery: false, note: "更新渠道", mutating: true },
      { idx: 4, m: "DELETE", path: "/api/v1/admin/channels/{id}", hasBody: false, hasQuery: false, note: "删除渠道", mutating: true },
    ],
    defaultBodies: { "/api/v1/admin/channels": sub2APIChannel, "/api/v1/admin/channels/{id}": JSON.stringify({ name: "supplier-openai", models: "gpt-4o-mini" }, null, 2) },
    defaultQueries: { "/api/v1/admin/channels": JSON.stringify({ p: "1", page_size: "20", status: "" }, null, 2) },
  },
};

// newapi 谱系(newapi / newapi-seller / 后续变体)共用 newapi 特有表单项。
// 判定的唯一权威在后端 newapi.IsFamily —— 这里只做显示层同步。
export const isNewAPIFamily = (adapterType: string) => adapterType === "newapi" || adapterType.startsWith("newapi-");

// newapi 谱系各变体在「未配置业务模块路径」时的默认模块。
// 与后端 profile.go 的 DefaultModulePath 一一对应。
const NEWAPI_DEFAULT_MODULE: Record<string, string> = {
  newapi: "",
  "newapi-seller": "seller",
};

// 业务模块路径规整：只去首尾空白与斜杠（与后端 NormalizeModulePath 同义）。
// 路径大小写敏感，这里不做任何大小写/字符改写。
export function normalizeModulePath(raw: string | undefined): string {
  return (raw ?? "").trim().replace(/^\/+|\/+$/g, "");
}

function channelBaseOf(modulePath: string): string {
  return modulePath ? `/api/${modulePath}/channel` : "/api/channel";
}

// profileForSite 按站点自己的业务模块路径重写控制台端点前缀（Q7）。
//
// 为什么需要：控制台是「按站点测接口」的工具，测的地址必须与实际分发地址
// 完全一致。卖家站是 /api/seller/channel，同质站点是 /api/zzz/supplier/channel，
// 两者共用同一份 profile；若把前缀写死，运营每接一台同质站点都要手改路径，
// 改错了才发现对不上。
//
// 只有 new-api 谱系参与重写：其它协议(如 sub2api)的路径与 module_path 无关。
export function profileForSite(adapterType: string, rawModulePath?: string): ConsoleProfile | undefined {
  const profile = RELAY_PROFILES[adapterType];
  if (!profile) return undefined;
  if (!isNewAPIFamily(adapterType)) return profile;

  const modulePath = normalizeModulePath(rawModulePath) || NEWAPI_DEFAULT_MODULE[adapterType] || "";
  const source = channelBaseOf(NEWAPI_DEFAULT_MODULE[adapterType] ?? "");
  const target = channelBaseOf(modulePath);
  if (source === target) return profile;

  const rewrite = (path: string) =>
    path === source || path.startsWith(`${source}/`) ? `${target}${path.slice(source.length)}` : path;
  const rewriteMap = (map: Record<string, string>) =>
    Object.fromEntries(Object.entries(map).map(([key, value]) => [rewrite(key), value]));

  return {
    ...profile,
    endpoints: profile.endpoints.map((endpoint) => ({ ...endpoint, path: rewrite(endpoint.path) })),
    defaultBodies: rewriteMap(profile.defaultBodies),
    defaultQueries: rewriteMap(profile.defaultQueries),
    probePath: profile.probePath ? rewrite(profile.probePath) : undefined,
  };
}

export function relayAuthHeaderLine(adapterType: string, hint: string, platformUserID: number): string {
  if (adapterType === "sub2api") return `x-api-key: ${hint || "••••••"} (redacted) 或 Authorization: Bearer <jwt>`;
  // 卖家变体用「系统访问令牌」即可，不需要 New-Api-User（实测该头可有可无）。
  if (adapterType === "newapi-seller") return `Authorization: Bearer ${hint || "••••••"} (redacted)`;
  return `Authorization: Bearer ${hint || "••••••"} (redacted)${platformUserID > 0 ? `\nNew-Api-User: ${platformUserID}` : ""}`;
}
